export default "__VITE_ASSET__WgfMSuW3__"